/**
 * Server option lists arrive as `{ label, value }` — see
 * Management::UserFilterOptions and Management::UserDetail. KeyDS `Select` and
 * `OptionsList` want `{ id, label }`, and an id is a string: a numeric value such
 * as a phone country code has to be stringified or the option never matches the
 * field's value.
 */
const toSelectOptions = (options = []) =>
  options.map((option) => ({ id: String(option.value), label: option.label }));

/**
 * The same list, guaranteed to contain the value on file.
 *
 * A KeyDS Select derives its displayed label by looking the value up among its
 * options, so a stored value with no matching option renders the field *blank* —
 * not wrong-looking, just empty, while still holding the value and re-saving it.
 * These columns are free text of long standing: job_role holds snake_case,
 * titleized and bare lowercase spellings (ManagementUsersQuery normalises both
 * sides when it filters on them) and country_code is nullable with no constraint.
 *
 * An unrecognised value is offered as its own label, so the field shows what the
 * record actually holds. That is worse-looking than a proper label and much better
 * than showing nothing.
 */
export const withStoredValue = (options = [], current) => {
  if (
    !current ||
    options.some(({ value }) => String(value) === String(current))
  ) {
    return options;
  }

  return [{ label: current, value: current }, ...options];
};

export default toSelectOptions;
